import React from 'react';
import { cn } from './utils';

export const Button = React.forwardRef(({ className, variant = "default", size = "default", ...props }, ref) => {
  const variants = {
    default: "bg-primary-600 text-white hover:bg-primary-700 shadow-sm hover:shadow-glow active:scale-95",
    outline: "border-2 border-surface-200 bg-white hover:bg-surface-50 text-surface-700 hover:border-primary-300",
    ghost: "hover:bg-surface-100 text-surface-600 hover:text-primary-700",
    danger: "bg-red-500 text-white hover:bg-red-600 shadow-sm active:scale-95",
    accent: "bg-accent-500 text-white hover:bg-accent-600 shadow-sm active:scale-95",
  };

  const sizes = {
    default: "h-10 px-5 py-2",
    sm: "h-8 rounded-lg px-3 text-xs",
    lg: "h-12 rounded-xl px-8 text-base",
    icon: "h-10 w-10",
  };

  return (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    />
  );
});
Button.displayName = "Button";